/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $ApproveDoctorExtraSpecialtiyRequest = {
  properties: {
    professionalId: {
      type: 'string',
      isRequired: true,
    },
    doctorExtraSpecialtyId: {
      type: 'string',
      isRequired: true,
    },
  },
} as const;
